import React, {Component} from 'react'
import { NavLink as Link} 	from "react-router-dom";
import {PropTypes} from 'prop-types'
import Icon from 'antd/lib/icon'
import TooltipElement from './TooltipElement';

class ResourceView extends Component {

    static propTypes = {
        schedulerData: PropTypes.object.isRequired,
        contentScrollbarHeight: PropTypes.number.isRequired,
        slotClickedFunc: PropTypes.func,
        slotItemTemplateResolver: PropTypes.func,
        toggleExpandFunc: PropTypes.func,
        isMonthView: PropTypes.bool,
    }

    render() {

        const {schedulerData, contentScrollbarHeight, slotClickedFunc, slotItemTemplateResolver, toggleExpandFunc, isMonthView} = this.props;
        const {renderData} = schedulerData;

        let width = schedulerData.getResourceTableWidth() - 2;
        let paddingBottom = contentScrollbarHeight;
        let displayRenderData = renderData.filter(o => o.render);

        let resourceList = displayRenderData.map((item) => {

            let indents = [];
            for(let i=0;i<item.indent;i++) {
                indents.push(<span key={`es${i}`} className="expander-space"></span>);
            }
            let indent = <span key={`es${item.indent}`} className="expander-space"></span>;
            if(item.hasChildren) {
                indent = item.expanded ? (
                    <Icon type="minus-square" key={`es${item.indent}`} style={{}} className=""
                        onClick={() => {
                            if(!!toggleExpandFunc)
                                toggleExpandFunc(schedulerData, item.slotId);
                        }}/>
                ) : (
                    <Icon type="plus-square" key={`es${item.indent}`} style={{}} className=""
                        onClick={() => {
                            if(!!toggleExpandFunc)
                                toggleExpandFunc(schedulerData, item.slotId);
                        }}/>
                );
            }
            indents.push(indent);

            let resourceName = (
                <span className="slot-cell">
                    {indents}
                    <span className="slot-text">
                        <span>{item.slotName}</span>
                        {item.skillName && (
                            <>
                                <small>({item.skillName})</small>
                            </>
                        )}
                    </span>
                </span>
            );

            let slotName = (item.slotName && item.skillName)
                ? item.slotName + "<br />(" + item.skillName + ")"
                : item.slotName;

            let a = slotClickedFunc !== undefined ? <span className="slot-cell">{indents}<Link to="#" className="slot-text" onClick={() => {
                slotClickedFunc(schedulerData, item);
            }}>{item.slotName}</Link></span>
                : resourceName;
            let slotItem = (
                <div className="header2-text" style={{textAlign: "left"}}>
                    <TooltipElement title={slotName} id={item.slotId}>
                        {a}
                    </TooltipElement>
                </div>
            );
            if(!!slotItemTemplateResolver) {
                let temp = slotItemTemplateResolver(schedulerData, item, slotClickedFunc, width, "overflow-text header2-text");
                if(!!temp)
                    slotItem = temp;
            }

            let tdStyle = {height: item.rowHeight};
            if(item.groupOnly) {
                tdStyle = {
                    ...tdStyle,
                    backgroundColor: schedulerData.config.groupOnlySlotColor
                };
            }

            let resourceHeaderClass = (!isMonthView  && item && (item.parentId === undefined)) ? "contractor-class" : "";
            let unassignedRowClass = item && item.slotType === "unassigned" ? " not-scheduled-row" : "";
            return (
                <tr key={item.slotId}>
                    <td data-resource-id={item.slotId} className={'resource-name ' + resourceHeaderClass + unassignedRowClass} style={tdStyle}>
                        {slotItem}
                    </td>
                </tr>
            );
        });

        return (
            <div style={{paddingBottom: paddingBottom}}>
                <table className="resource-table">
                    <tbody>
                        {resourceList}
                    </tbody>
                </table>
            </div>
        )
    }
}

export default ResourceView